// extracted by mini-css-extract-plugin
export default {"logo":"CompanyIcon_logo__UUyxf","logo_wrap":"CompanyIcon_logo_wrap__gY4zU"};